import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import ReactLoading from 'react-loading';
import MetaTags from 'react-meta-tags';
import '../css/blog.css'


export default class Mails extends Component {
  constructor() {
    super();
    this.state = {
      listOfPositions: [],
      name: '',
      title: '',
      createDate: '',
      createTime: '',
      mail: '',
      value: '',
      loading: true,
      repeat:''
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  handleChange(e) {
    this.setState({repeat: e.target.value});
  }
  handleSave(event) {
    event.preventDefault();
    window.location = ('/UserProfile/MailBox');
    let id = this.props.match.params.id
    const mailsRepeatRef = firebase.database().ref('mailBox/').child(id)
    mailsRepeatRef.update({
      repeat: this.state.repeat
    })

  }

  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      setTimeout(() => this.setState({ loading: false }), 2400);
        let theId = this.props.match.params.id;
        const mailsRef = firebase.database().ref('mailBox/').orderByChild('id').equalTo(theId);
        mailsRef.on('value', snap => {
          snap.forEach((child) => {
            this.setState({
              mail: child.val().mail,
              name: child.val().name,
              title: child.val().title,
              createTime: child.val().createTime,
              createDate: child.val().createDate,
              value: child.val().value,
              id: child.val().id,
              repeat: child.val().repeat
            })
          })
        })



    })

  }


  render() {
    const { loading } = this.state;

    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    const Items = [
      '未回覆','已回覆'
    ].map((Item) => {
      return <option key={Item} value={Item}>{Item}</option>
    })
    return(
      <div className="container-fluid blogs">
       <div className="row">
        <MetaTags>
            <title>草學藥事 || {this.state.title}</title>
            <meta id="og-title" property="og:title" content={this.state.title} />
        </MetaTags>
        <article style={Jeyu.blogBg}>
         <h1>{this.state.title}</h1>
        </article>

        <div className="container">
         <div className="row" style={Jeyu.hasPadding}>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
           <div style={Jeyu.mailBox} >
             <p>寄信人: {this.state.name}</p>
             <p>信箱: {this.state.mail}</p>
            <sup>{this.state.createDate} / {this.state.createTime}</sup>
            <p>{this.state.value}</p>
           </div>
           
           <form onSubmit={this.handleSave} >
            <select value={this.state.repeat} onChange={this.handleChange}>
              {Items}
            </select>
            <input type="submit" value="Submit" className="btnDefault" />
            <Link to="/UserProfile/MailBox" className="btnDefault">返回 MailBox</Link>
           </form>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}


const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  },
  blogBg: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '130px 20px 50px',
    textAlign: 'center'
  },
  hasPadding: {
    padding: '35px 0',
    height: '100vh'
  },
  hasMarginTop: {
    marginBottom: 20
  },
  photoBox: {
    maxWidth: '100%'
  },
  mailBox: {
      padding: 20,
      border: '3px solid #dcdcdd'
  }
}



// WEBPACK FOOTER //
// ./src/post/Mails.js